import React from 'react';
import { Star, ShieldCheck, Zap, Award, Users } from 'lucide-react';
export function ValidatorBar() {
  return <div className="bg-white border-y border-warm-200 py-4" data-id="element-295">
      <div className="max-w-6xl mx-auto px-4" data-id="element-296">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-297">
          {/* Stars */}
          <div className="flex items-center gap-2" data-id="element-298">
            <div className="flex gap-0.5" data-id="element-299">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-gold-500 text-gold-500" data-id="element-300" />)}
            </div>
            <span className="text-sm text-text-body" data-id="element-301">
              <strong className="text-text-dark" data-id="element-302">4.9/5</strong> • 250+ familias
            </span>
          </div>

          {/* Trust Icons */}
          <div className="flex flex-wrap justify-center gap-4 md:gap-6" data-id="element-303">
            <div className="flex items-center gap-1.5 text-text-body text-sm" data-id="element-304">
              <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-305" />
              <span data-id="element-306">Pago seguro</span>
            </div>
            <div className="flex items-center gap-1.5 text-text-body text-sm" data-id="element-307">
              <Zap className="w-4 h-4 text-primary-500" data-id="element-308" />
              <span data-id="element-309">Entrega inmediata</span>
            </div>
            <div className="flex items-center gap-1.5 text-text-body text-sm" data-id="element-310">
              <Award className="w-4 h-4 text-gold-500" data-id="element-311" />
              <span data-id="element-312">Garantía 7 días</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}